/**
 * Utility functions for the sessions view.
 */

/**
 * Build ResLink URL for copying (uses session connection_method to determine domain).
 * Production sessions use pixels.persona-ai.ai, all others use stagingpixels.
 */
export const buildResLinkUrl = (
  launchArgsId: string,
  orgId: string,
  connectionMethod?: string
): string => {
  const isProduction = connectionMethod === "production";
  const domain = isProduction ? "pixels.persona-ai.ai" : "stagingpixels.persona-ai.ai";
  return `https://${domain}/login?res_link_params_id=${launchArgsId}&org_id=${orgId}`;
};
